import React, { Component } from 'react';
import cx from 'classnames';
import memoizeOne from 'memoize-one';
import Popover from 'react-popover';
import Icon from '../../Icon';
import Button from '../../Button';
import Link from '../../Link';
import '../styles/_feature-tooltip.scss';
import { Image } from '../../Image';

























class FeatureToolTip extends Component


{
  modalRef = React.createRef();

  iconRef = React.createRef();

  videoPlayerRef = React.createRef();

  state = {
    featuretooltip: false,
    playing: false,
    modalWidth: 0
  };


  withNoEventPropagation = memoizeOne((fn) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    fn(e);
  });

  componentDidMount() {
    const {
      footerButton
    } = this.props;

    if (footerButton) {
      this.setState({ modalWidth: 300 });
    } else {
      this.setState({ modalWidth: 220 });
    }
  }

  handleOpenFeatureToolTip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prevState) => ({
      featuretooltip: !prevState.featuretooltip,
      playing: false
    }));
  };

  handlePlayVideo = () => {
    this.setState((prevState) => ({
      playing: !prevState.playing
    }));
  };

  handleClickPrimaryButton = () => {
    const { onClickPrimaryButton } = this.props;
    if (onClickPrimaryButton) {
      this.setState({ featuretooltip: false });
      onClickPrimaryButton();
    }
    this.setState({ featuretooltip: false });
  };

  renderContent = () => {
    const {
      videoUrl,
      children,
      footerButton,
      footerLink,
      className,
      primaryButtonText,
      footerLinkText
    } = this.props;

    const {
      playing = false,
      modalWidth
    } = this.state;

    return (
      <div
        className={cx('feature-tooltip__modal', className)}
        style={{
          width: `${modalWidth}px`
        }}
        data-testid="modal"
        id="modal">

        {videoUrl &&
        <div className="feature-tooltip__modal-video">
          {!playing &&
          <Icon
            name="play"
            size={24}
            color="white"
            onClick={this.handlePlayVideo}
            className="feature-tooltip__modal-video__play"
            id="play" />}


          <video
            key={videoUrl}
            onClick={this.handlePlayVideo}
            controls
            data-testid="video">

            <source src={videoUrl} />
            <track kind="captions" />
          </video>
        </div>}

        <div className="feature-tooltip__modal-content">
          {children}
        </div>

        {footerButton &&
        <div className="feature-tooltip__modal-footer" data-testid="footer">
            {footerLink ? <Link to={footerLink}>{footerLinkText || 'Learn more'}</Link> : <>&nbsp;</>}
            <Button
            onClick={() => this.handleClickPrimaryButton()}
            id="footer-btn">

              {primaryButtonText || 'Sounds Great!'}
            </Button>
          </div>}

      </div>);

  };

  render() {
    const {
      iconName,
      iconSize,
      iconColor,
      image,
      preferPlace = 'right',
      hover = false
    } = this.props;

    const {
      featuretooltip
    } = this.state;
    return (
      <div
        className="feature-tooltip"
        ref={(node) => {this.modalRef = node;}}
        id="feature-tooltip">

        <Popover
          isOpen={featuretooltip}
          preferPlace={preferPlace}
          className="feature-tooltip__popover"
          enterExitTransitionDurationMs={0}
          body={this.renderContent()}
          tipSize={0.01}
          onOuterAction={this.withNoEventPropagation(this.handleOpenFeatureToolTip)}>

          <div
            onMouseEnter={hover ? this.handleOpenFeatureToolTip : undefined}
            onMouseLeave={hover ? this.handleOpenFeatureToolTip : undefined}>

            {image ?
            <Image
              {...image}
              alt="feature--image"
              onClick={this.handleOpenFeatureToolTip}
              className="image feature-tooltip__image" /> :


            <Icon
              name={iconName || 'faq'}
              size={iconSize || 18}
              color={iconColor || 'nevada'}
              onClick={this.handleOpenFeatureToolTip}
              className="icon feature-tooltip__icon" />}


          </div>
        </Popover>
      </div>);

  }
}

export default FeatureToolTip;